import React, { useState, Fragment, useEffect } from "react";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { Dialog, DialogActions, DialogContent, Grid } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import Input from "Components/Input/Input";
import { read } from "Helpers/LocalStorage";
import { UpdateSettingProfile } from "Stores/actions";
import Translator from "Languages/Utility/Translator";
import millimeterMask from "Components/Input/components/millimeterMask";
import { Alert } from "@material-ui/lab";
import * as R from "ramda";
import TagFormatter from "Components/TagFormatter/TagFormatter";
import MuiButton from "Components/MuiButton/MuiButton";
import { ReactSVG } from "react-svg";
import SettingIcon from "Assets/svg/icon/Gear_nv.svg";
import infoIcon from "Assets/svg/icon/info.svg";
import { useTranslation } from "react-i18next";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import MuiCheckBoxGroup from "Components/MuiCheckboxGroup/MuiCheckboxGroup";
import showNotify from "Helpers/Notify";

function ProfileSetting({ reGetOnBack }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { dasteProfileList, selectedDasteProfile } = useSelector((state) => ({
    dasteProfileList: state.profile.dasteProfileList,
    selectedDasteProfile: state.profile.selectedDasteProfile,
  }));
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [change, setChange] = useState(false);
  const [formValid, setFormValid] = useState({});
  const [controls, setControls] = useSetState({
    zobFrame: {
      type: "millimeter",
      value: 0,
      validation: {
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
      },
      display: true,
    },
    zobSash: {
      type: "millimeter",
      value: 0,
      validation: {
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
      },
      display: true,
    },
    sarboreshMolion: {
      type: "millimeter",
      value: 0,
      validation: {
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
      },
      display: true,
    },
    sarboreshMolionKatibe: {
      type: "millimeter",
      value: 0,
      validation: {
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
      },
      display: true,
    },
    fazayeAzadAverhung: {
      type: "millimeter",
      value: 0,
      validation: {
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
        isDecimal: true,
      },
      display: true,
    },
    badkhorFrameSash: {
      type: "millimeter",
      value: 0,
      validation: {
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
      },
      display: true,
    },
    badkhorMolion: {
      type: "millimeter",
      value: 0,
      validation: {
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
      },
      display: true,
    },
    hampushaniW: {
      type: "millimeter",
      value: 0,
      validation: {
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
        isDecimal: true,
      },
      display: true,
    },
    hampushaniH: {
      type: "millimeter",
      value: 0,
      validation: {
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
        isDecimal: true,
      },
      display: true,
    },
    hampushaniKaman: {
      type: "millimeter",
      value: 0,
      validation: {
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
        isDecimal: true,
      },
      display: true,
    },
    sizeDarpush: {
      type: "millimeter",
      value: 0,
      validation: {
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
      },
      display: true,
    },
    badkhorPanelFrame: {
      type: "millimeter",
      value: 0,
      validation: {
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
      },
      display: true,
    },
    badkhorPanelMolion: {
      type: "millimeter",
      value: 0,
      validation: {
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
      },
      display: true,
    },
    IncArcFrame: {
      type: "millimeter",
      value: 0,
      validation: {
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
      },
      display: true,
    },
    IncArcSash: {
      type: "millimeter",
      value: 0,
      validation: {
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
      },
      display: true,
    },
    IncArcGlazing: {
      type: "millimeter",
      value: 0,
      validation: {
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
      },
      display: true,
    },
    IsZehvar90: {
      type: "checkbox",
      items: [{ value: false, key: "IsZehvar90" }],
      display: true,
    },
  });
  const handleDialog = () => setOpenDialog(!openDialog);

  const onEnter = () => {
    setFormValid({});
    setControls({ zobFrame: { value: selectedDasteProfile.FusionFrame } });
    setControls({ zobSash: { value: selectedDasteProfile.FusionSash } });
    setControls({
      sarboreshMolion: { value: selectedDasteProfile.CutMolionNormal },
    });
    setControls({
      sarboreshMolionKatibe: { value: selectedDasteProfile.CutMolionKatibeh },
    });
    setControls({
      fazayeAzadAverhung: { value: selectedDasteProfile.FreeOverHung },
    });
    setControls({
      badkhorFrameSash: { value: selectedDasteProfile.BreakGlassFrame },
    });
    setControls({
      badkhorMolion: { value: selectedDasteProfile.BreakGlassMolion },
    });
    setControls({ hampushaniW: { value: selectedDasteProfile.OverlapW } });
    setControls({ hampushaniH: { value: selectedDasteProfile.OverlapH } });
    setControls({ hampushaniKaman: { value: selectedDasteProfile.OverlapA } });
    setControls({
      sizeDarpush: {
        value: selectedDasteProfile.SizeCapOverhung,
        display: selectedDasteProfile.Pop === 1 ? true : false,
      },
    });
    setControls({
      badkhorPanelFrame: { value: selectedDasteProfile.BreakPanelFrame },
    });
    setControls({
      badkhorPanelMolion: { value: selectedDasteProfile.BreakPanelMolion },
    });
    setControls({
      IncArcFrame: {
        value: selectedDasteProfile.IncArcFrame,
        display: selectedDasteProfile.Pop === 1 ? true : false,
      },
    });
    setControls({
      IncArcSash: {
        value: selectedDasteProfile.IncArcSash,
        display: selectedDasteProfile.Pop === 1 ? true : false,
      },
    });
    setControls({
      IncArcGlazing: {
        value: selectedDasteProfile.IncArcGlazing,
        display: selectedDasteProfile.Pop === 1 ? true : false,
      },
    });
    setControls({
      IsZehvar90: {
        items: [{ value: selectedDasteProfile.IsZehvar90, key: "IsZehvar90" }],
        display: selectedDasteProfile.Struct === 2 ? true : false,
      },
    });
  };

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (change) {
      if (
        !R.isEmpty(formValid) &&
        Object.values(formValid).every((item) => item === true)
      ) {
        const {
          zobFrame,
          zobSash,
          sarboreshMolion,
          sarboreshMolionKatibe,
          fazayeAzadAverhung,
          badkhorFrameSash,
          badkhorMolion,
          hampushaniW,
          hampushaniH,
          hampushaniKaman,
          sizeDarpush,
          badkhorPanelFrame,
          badkhorPanelMolion,
          IncArcFrame,
          IncArcSash,
          IncArcGlazing,
          IsZehvar90,
        } = controls;
        try {
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: selectedDasteProfile.Id,
            overlapW: +convertToEnglishNumber(hampushaniW.value),
            overlapH: +convertToEnglishNumber(hampushaniH.value),
            overlapA: +convertToEnglishNumber(hampushaniKaman.value),
            fusionFrame: +convertToEnglishNumber(zobFrame.value),
            fusionSash: +convertToEnglishNumber(zobSash.value),
            cutMolionNormal: +convertToEnglishNumber(sarboreshMolion.value),
            cutMolionKatibeh: +convertToEnglishNumber(
              sarboreshMolionKatibe.value
            ),
            breakGlassFrame: +convertToEnglishNumber(badkhorFrameSash.value),
            breakGlassMolion: +convertToEnglishNumber(badkhorMolion.value),
            isZehvar90: IsZehvar90.items[0].value,
            idSysPrice: 0,
            breakPanelFrame: +convertToEnglishNumber(badkhorPanelFrame.value),
            breakPanelMolion: +convertToEnglishNumber(badkhorPanelMolion.value),
            freeOverhung: +convertToEnglishNumber(fazayeAzadAverhung.value),
            SizeCapOverhung: +convertToEnglishNumber(sizeDarpush.value),
            IncArcFrame: +convertToEnglishNumber(IncArcFrame.value),
            IncArcSash: +convertToEnglishNumber(IncArcSash.value),
            IncArcGlazing: +convertToEnglishNumber(IncArcGlazing.value),
          };

          await dispatch(UpdateSettingProfile(data));
          let selectedIndex = -1;
          dasteProfileList.map((item, index) => {
            if (item.Id === selectedDasteProfile.Id) {
              selectedIndex = index;
            }
          });
          await reGetOnBack(false, selectedIndex);
          handleDialog();
        } catch (err) {
          console.error("[catch error]", err);
        }
      } else {
        if (Object.keys(formValid).length === 0) {
          showNotify({
            text: t("correctFormDataRequired"),
            customClass: "warning",
          });
        }
      }
    } else {
      handleDialog();
    }
    setLoading(false);
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
    setChange(true);
  };

  const onChangeCheckbox = (e, name, index) => {
    const items = controls[name].items;
    items[index] = { ...items[index], value: e.currentTarget.checked };
    setControls({ [name]: { items: items } });
    setFormValid((prev) => ({ ...prev, [name]: true }));
    setChange(true);
  };

  return (
    <>
      <MuiIconButton
        title={<Translator id={"Setting"} />}
        icon={<ReactSVG src={SettingIcon} />}
        onClick={handleDialog}
        className="fix-size"
        disabled={
          selectedDasteProfile.Disable ||
          (selectedDasteProfile.IsG && read("StypeU") !== "1") ||
          (read("addSeriProfileRules").accessUpdate === false &&
            read("StypeU") !== "1")
        }
      />
      <BackDropLoading loading={loading} />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        TransitionProps={{ onEnter: onEnter }}
        fullWidth
        maxWidth="md"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>
              {" "}
              {<Translator id={"Setting"} />} {selectedDasteProfile.Name}
            </p>
            <TagFormatter struct={selectedDasteProfile?.NameScomposition} />
          </div>
          <DialogContent style={{ overflow: "visible" }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Alert
                  severity="info"
                  variant="outlined"
                  icon={<ReactSVG src={infoIcon} />}
                >
                  <>{`${t("typePriceCalculation")} : ${
                    selectedDasteProfile?.NameSysPrice
                  }`}</>
                </Alert>
              </Grid>
              {Object.keys(controls).map((key) => {
                return (
                  <Fragment key={key}>
                    {controls[key].type === "millimeter" &&
                      controls[key].display && (
                        <Grid item md={2} sm={4} xs={12}>
                          <Input
                            setValue={setValue.bind(this)}
                            name={key}
                            value={controls[key].value}
                            validation={controls[key].validation}
                            label={<Translator id={key} />}
                            type={controls[key].type}
                            endIcon={<Translator id="millimeter" />}
                            inputComponent={millimeterMask}
                            minLength={controls[key]?.validation?.minLength}
                            maxlength={controls[key]?.validation?.maxLength}
                          />
                        </Grid>
                      )}
                  </Fragment>
                );
              })}
              {Object.keys(controls).map((key) => {
                return (
                  <Fragment key={key}>
                    {controls[key].type === "checkbox" &&
                      controls[key].display && (
                        <Grid item xs={12} className="mx-1">
                          <MuiCheckBoxGroup
                            name="IsZehvar90"
                            items={controls[key].items}
                            onChange={onChangeCheckbox}
                            translate={true}
                            className="horizontalCheckbox"
                          />
                        </Grid>
                      )}
                  </Fragment>
                );
              })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
              disabled={loading}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
              disabled={loading}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default ProfileSetting;
